module.exports = __webpack_public_path__ + "img/aboutus.99b686fe.png";